var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResButtonsStudyRem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Black{fill:#727272;}\r\n\t.Yellow{fill:#FFB115;}\r\n\t.Blue{fill:#1177D7;}\r\n\t.Green{fill:#039C23;}\r\n\t.Red{fill:#D11C1C;}\r\n\t.White{fill:#FFFFFF;}\r\n\t.st0{opacity:0.75;}\r\n\t.st1{opacity:0.5;}\r\n\t.st2{opacity:0.25;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AddGroupHeader"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    className: "Blue",
    width: 14,
    height: 6
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Black",
    d: "M20,18H6v-2h14V18z M20,20H6v2h14V20z M20,24H6v2h14V24z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "Black",
    d: "M22,28H4V6h16h2h0.2l1.6-1.6C23.6,4.2,23.3,4,23,4H3C2.5,4,2,4.5,2,5v24c0,0.5,0.5,1,1,1h20c0.5,0,1-0.5,1-1 v-9.2l-2-2V28z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Red",
    points: "30,7 27,10 24,7 22,9 25,12 22,15 24,17 27,14 30,17 32,15 29,12 32,9  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResButtonsStudyRem);
export default __webpack_public_path__ + "static/media/resButtonsStudyRem.38e02617d9b4ebbfaecdd6c9a5f0c9e6.svg";
export { ForwardRef as ReactComponent };